import { withIronSession } from 'next-iron-session';
import React, { useEffect, useState } from 'react';

import * as Sentry from '@sentry/node';
import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import { DateTime } from 'luxon';
import { useRouter } from 'next/router';
import { Col, Row } from 'react-bootstrap';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';
import BookingAddressInput from '../components/BookingAddressInput';
import BookingIndicators from '../components/BookingIndicators';
import BookingPayment from '../components/BookingPayment';
import BookingStickyFooter from '../components/BookingStickyFooter';
import BookingSummary from '../components/BookingSummary';
import BookingTermsAndConditions from '../components/BookingTermsAndConditions';
import BookTopHero from '../components/BookTopHero';
import Head from '../components/head';
import Layout from '../components/Layout';
import OpenGraphDescription from '../components/OpenGraphDescription';
import OpenGraphTitle from '../components/OpenGraphTitle';
import Section from '../components/Section';
import SwooptyBg from '../components/SwooptyBg';
import TipSelection from '../components/TipSelection';
import { FranchiseeProvider } from '../context/Franchisee';
import { FranchiseeState } from '../context/Franchisee/franchisee.types';
import { LeadProvider } from '../context/Lead';
import { LeadAppointment, LeadState } from '../context/Lead/lead.types';
import { PaymentProvider } from '../context/Payment';
import {
  setCookieData,
  setLockID,
  setSelectedTimeSlot,
} from '../features/user/userSlice';
import db from '../SDKs/firebase/firebase';
import Gataware from '../SDKs/Gataware';
import leadConfig from '../sessions/lead';
export const getServerSideProps = withIronSession(async ({ req, res }) => {
  try {
    const leadId = req.session.get('leadId');
    const franchiseeId = req.session.get('franchiseeId');
    const cleaningDate = req.session.get('cleaningDate');

    // if there's no lead, redirect to booking page
    // if (!leadId) {
    //   res.setHeader('location', '/book/');
    //   res.statusCode = 302;
    //   return res.end();
    // }

    /*
      redirect if there is no cleaning date
      redirect if the cleaning would occure in less than 8 hours
     */
    // replace back for gataware
    // if (
    //   !cleaningDate ||
    //   DateTime.fromISO(cleaningDate) <= DateTime.local().plus({ hours: 8 })
    // ) {
    //   res.setHeader('location', '/schedule/');
    //   res.statusCode = 302;
    //   return res.end();
    // }

    const locationsResponseData = await Gataware.getLocations({
      ids: [franchiseeId],
    }).then((result) => JSON.parse(result.data));
    // console.log(locationsResponseData);

    const franchisees = await locationsResponseData.data.map((franchisee) =>
      camelcaseKeys(franchisee)
    );

    const leadRequest = Gataware.lead.checkIfLeadExists({ leadId });

    const [lead] = await Promise.all([leadRequest]);

    const [franchisee] = await franchisees;

    // otherwise, proceed to confirm page
    return { props: { franchisee, lead } };
  } catch (e) {
    // res.setHeaders('location', '/book/');
    // res.statusCode = 302;
    // return res.end();
    return { props: { franchisee: null, lead: null } };
  }
}, leadConfig);

interface ConfirmPageProps {
  franchisee: FranchiseeState;
  lead: LeadState;
}

const Confirm: React.FC<ConfirmPageProps> = ({
  franchisee,
  lead,
}: ConfirmPageProps) => {
  const [customerExists, setCustomerExists] = useState<boolean>(false);
  const [isReadyForPayment, setIsReadyForPayment] = useState<boolean>(false);
  const [autoLeadTipApplied, setAutoLeadTipApplied] = useState<boolean>(true);
  const [tip, setTip] = useState<number>(0);
  const [checkboxValue, setCheckboxValue] = useState<boolean>(false);

  const router = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!lead?.email) return;
    axios
      .post('/api/check-if-customer-exists/', { email: lead.email })
      .then((res) => {
        if (res.status === 200) {
          setCustomerExists(res.data.data.has_completed_appointments)
          console.log('Anything')
          console.log('Does the customer exist?', customerExists)
        } else {
          setCustomerExists(false)
        }
      }).catch(err => {
        console.log('In the catch of check if customer exists')
        Sentry.captureException(err)
      });
  }, [lead?.email]);

  useEffect(() => {
    if (!lead?.id) {
      router.push(`/book`);
    }
  }, [lead?.id]); 

  //dashboard idle detection
  const handleOnActive = () => {
    axios
      .get('/api/lead-session/')
      .then((res) => {
        const lead = res.data.data.lead.id;
        const userStatusDatabaseRef = db.ref(`/online/${lead}`);
        userStatusDatabaseRef.update({
          leadID: lead,
        });
      })
      .catch((err) => console.log(err));
  };

  useIdleTimer({
    timeout: 3000,
    onActive: handleOnActive,
  });

  const setTipHandler = (val) => {
    setTip(val);
  };
  const checkBoxHandler = (val) => {
    setCheckboxValue(val);
  };
  const autoLeadTipHandler = () => {
    setAutoLeadTipApplied(false);
  };

  const handleReadyForPayment = (data) => {
    setIsReadyForPayment(data);
  };

  return (
    <FranchiseeProvider franchiseeValue={franchisee}>
      <LeadProvider>
        <Layout booking alternateFooter={true}>
          <Head
            slug='confirm'
            title='Confirm | Two Maids '
            description='Confirm Your Booking with Two Maids .'
          />
          <OpenGraphTitle title='Confirm | Two Maids ' />
          <OpenGraphDescription>
            {/* Add Confirm description here */}
            Confirm Your Booking with Two Maids .
          </OpenGraphDescription>
          <BookTopHero
            page={'confirm'}
            title={`Set Your Home Address`}
            subheading={`Use our easy, no-hassle pricing feature and instantly book your cleaning!`}
          />
          <div className='top-background-dots'></div>

          <Section  className='booking-input-container'>
            <Row className='justify-content-center'>
              <Col xs={12} lg={10} xl={9}>
                <BookingAddressInput customerExists={customerExists} readyForPayment={handleReadyForPayment} />
              </Col>
            </Row>
          </Section>
          <PaymentProvider>
            <Section padding='bottom' className='booking-input-container'>
              <Row className='justify-content-center'>
                <Col xs={12} lg={10} xl={9}>
                  <BookingPayment tip={tip} checkboxValue={checkboxValue} customerExists={customerExists} readyForPayment={isReadyForPayment} />
                  <TipSelection
                    setTipHandler={setTipHandler}
                    autoLeadTipHandler={autoLeadTipHandler}
                    checkBoxHandler={checkBoxHandler}
                    source={'confirm'}
                  />
                  <BookingTermsAndConditions
                    autoLeadTipApplied={autoLeadTipApplied}
                  />
                  <BookingSummary className='mb-5' />
                </Col>
              </Row>
            </Section>
            <BookingStickyFooter tip={tip} />
          </PaymentProvider>
        </Layout>
      </LeadProvider>
    </FranchiseeProvider>
  );
};

export default Confirm;
